module.exports = __webpack_public_path__ + "/build/web/images/hero-training.872494625c327f04d7fa6273efcf48a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-training.jpg
// module id = 151
// module chunks = 13